<template>
    <div v-bind:class="{show : dialogueVisible == true, displayblock : dialogueVisible == true}" class="modal sustainable-component update-block-grade" tabindex="-1" v-bind:id="'customModal' + getId()" role="dialog">
        <div class="modal-dialog" v-bind:class="size" role="document">
            <div class="modal-content">
                <div class="modal-header bg-primary">
                    Uppdatera
                </div>
                <div class="modal-body pb-0">
                    <div class="container-fluid p-0">
                        <div class="row">
                            <div class="col">
                                <v-text-field bg-color="white" label="Från och med månad" v-model="from" variant="outlined"></v-text-field>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <v-text-field bg-color="white" label="Till och med månad" v-model="to" variant="outlined"></v-text-field>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <v-text-field bg-color="white" label="Poäng" v-model="points" variant="outlined"></v-text-field>
                            </div>
                        </div>
                        
                    </div>
                </div>
                <div class="modal-footer pt-2 pb-1">
                    <v-btn color="blue-darken-1"
                           variant="text"
                           @click="close">
                        Stäng
                    </v-btn>
                    <v-btn color="blue-darken-1"
                           variant="text"
                           @click="save">
                        Spara
                    </v-btn>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import WageService from "../../../Services/WageService";
    import { getCurrentInstance } from 'vue'

    export default {
        emits: ['updated'],
        name: 'update-block-grade',
        props: {

        },
        methods: {
            getId() {
                return getCurrentInstance().uid;
            },
            close() {
                this.reset();
                this.dialogueVisible = false;
                this.thisModal.hide();
            },
            async save() {
                await WageService.updateBlockGrade(this.blockGradeId, this.gradeNumber, this.from, this.to, this.points)
                this.reset();
                this.dialogueVisible = false;
                this.thisModal.hide();
                this.$emit("updated");
            },
            open(item) {
                this.blockGradeId = item.BlockGradeId
                this.gradeNumber = item.GradeNumber;
                this.from = item.From;
                this.to = item.to;
                this.points = item.Points;
                this.description = item.Description;
                this.dialogueVisible = true;
                this.thisModal.show();
            },
            create() {
                this.reset();
                this.dialogueVisible = true;
                this.thisModal.show();
            },
            reset() {
                this.blockGradeId = null;
                this.description = null;
                this.gradeNumber = null;
                this.from = null;
                this.to = null;
                this.points = null;
            },
        },
        data() {
            return {
                description:null,
                blockGradeId:null,
                gradeNumber: null,
                from: null,
                to: null,
                points: null,
                dialogueVisible: false,
                thisModal: {},
            };
        },
        watch: {

        },
        mounted() {
            this.$el.remove();
            document.body.appendChild(this.$el);

            // eslint-disable-next-line
            this.thisModal = new bootstrap.Modal(document.getElementById('customModal' + this.getId()), {});

            //window.emitter.on('display_login', this.close);
        },
        // eslint-disable-next-line
        setup(props, { emit }) {}
    }
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .modal-content {
        border-radius: unset;
    }

    .modal-footer {
        border-top-color: transparent;
    }

    .modal-header {
        border-top-left-radius: unset;
        border-top-right-radius: unset;
    }
</style>
